export default "__VITE_ASSET__CFA6Jl_c__"